import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const alignStyles = ({ width = 'auto', overflow = 'initial', textAlign = 'left' }) => css`
  text-align: ${textAlign};
  overflow: ${overflow};
  width: ${width};
`;

export default styled(Flexer.Child)`
  && {
    ${alignStyles}
  }
`;
